import styled from 'styled-components';
import { PiFactoryDuotone, PiPlantDuotone } from 'react-icons/pi';

export const UCsDigestContainer = styled.div`
  background-color: ${(props) => props.theme.color.bg.primary};
  grid-area: environmentresults;
`;

export const Title = styled.h4`
  font-family: ${(props) => props.theme.font.title.family};
  font-size: ${(props) => props.theme.font.title.size.h4};
  line-height: ${(props) => props.theme.font.title.lineHeight.h4};
  color: ${(props) => props.theme.color.ui.orange};
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-family: ${(props) => props.theme.font.body.family};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
`;

export const ItemContainer = styled.div`
  display: flex;

  small {
    color: ${(props) => props.theme.color.text.disabled};
  }

  p {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) => props.theme.color.ui.success};
  width: 50px;
  height: 50px;
  border-radius: 25px;
`;

export const FactoryIcon = styled(PiFactoryDuotone)`
  color: ${(props) => props.theme.color.ui.success};
  font-size: 26px;
`;

export const PlantIcon = styled(PiPlantDuotone)`
  color: ${(props) => props.theme.color.ui.success};
  font-size: 26px;
`;

export const Equivalence = styled.span`
  display: block;
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: ${(props) => props.theme.font.body.size.small};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
`;

// Rodapé: fatores usados + link para a metodologia na Ajuda
export const Footnote = styled.div`
  margin-top: 8px;
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: ${(props) => props.theme.font.body.size.small};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};

  a {
    color: ${(props) => props.theme.color.ui.orange};
    font-weight: ${(props) => props.theme.font.body.weight.bold};
    text-decoration: none;
  }
`;
